// extracted by mini-css-extract-plugin
export default {"wordReveal":"WordRevealStandalone_wordReveal__vRMxP","word":"WordRevealStandalone_word__OL2lZ"};